var __slice = [].slice;

_.namespace(module, function(require) {
  var AWMF_GUIDELINE_PROFILE, AWMF_GUIDELINE_SECTIONS_CS, AWMF_IG_CANONICAL_BASE, AWMF_INTENDED_AUDIENCE_CS, AWMF_RECOMMENDATION_IDENTIFIER_SYSTEM, AWMF_RECOMMENDATION_PROFILE, AWMF_RECOMMENDATION_SYNTHESIS_CS, DEFAULT_INTENDED_AUDIENCE, DEFAULT_SYNTHESIS_TYPE, DISSOLVE_CANONICAL_BASE, EBM_GUIDELINE_PROFILE, EXT_SECTION_INTENDED_AUDIENCE, EXT_SECTION_LANGUAGE, EtdActions, EtdVotingStore, FEVIR_CODE_SYSTEM, FHIR_NAMED_ENTITIES, FHIR_VOID_TAGS, HtmlExport, IG_DISSOLVE_E, IG_EBM_ON_FHIR, IG_FHIR_BASE, QUESTION_VIEW_NAME_TO_PRINTOUT_TYPE, Question, QuestionDoc, SECTION_LANGUAGE, W, alt, generateGUID, mediator;
  alt = require('alt');
  EtdVotingStore = require('stores/etd_voting_store');
  generateGUID = require('base/lib/utils').generateGUID;
  HtmlExport = require('lib/html_export');
  mediator = require('mediator');
  EtdActions = require('actions/etd_actions');
  QuestionDoc = require('lib/db_docs/question_doc');
  Question = require('models/question');
  QUESTION_VIEW_NAME_TO_PRINTOUT_TYPE = require('lib/questions_helper').QUESTION_VIEW_NAME_TO_PRINTOUT_TYPE;
  W = require('when');
  IG_DISSOLVE_E = 'http://fhir.awmf.org/awmf.ig';
  IG_EBM_ON_FHIR = 'https://build.fhir.org/ig/HL7/ebm/';
  IG_FHIR_BASE = 'https://www.hl7.org/fhir/';
  DISSOLVE_CANONICAL_BASE = 'http://fhir.awmf.org/awmf.ig/StructureDefinition';
  AWMF_IG_CANONICAL_BASE = 'http://fhir.awmf.org/awmf.ig';
  EBM_GUIDELINE_PROFILE = 'http://hl7.org/fhir/uv/ebm/StructureDefinition/guideline';
  AWMF_GUIDELINE_PROFILE = 'http://fhir.awmf.de/StructureDefinition/AWMFGuideline';
  AWMF_RECOMMENDATION_PROFILE = "" + DISSOLVE_CANONICAL_BASE + "/recommendation";
  AWMF_RECOMMENDATION_SYNTHESIS_CS = "" + IG_DISSOLVE_E + "/CodeSystem/cs-recommendation-synthesis-type";
  AWMF_INTENDED_AUDIENCE_CS = "" + IG_DISSOLVE_E + "/CodeSystem/cs-intended-audience";
  AWMF_RECOMMENDATION_IDENTIFIER_SYSTEM = "" + AWMF_IG_CANONICAL_BASE + "/recommendations";
  FEVIR_CODE_SYSTEM = 'https://fevir.net/resources/CodeSystem/179423';
  AWMF_GUIDELINE_SECTIONS_CS = "" + IG_DISSOLVE_E + "/CodeSystem/cs-guideline-sections";
  EXT_SECTION_LANGUAGE = "" + IG_DISSOLVE_E + "/StructureDefinition/ext-section-language";
  EXT_SECTION_INTENDED_AUDIENCE = "" + IG_DISSOLVE_E + "/StructureDefinition/ext-section-intended-audience";
  SECTION_LANGUAGE = 'en';
  DEFAULT_INTENDED_AUDIENCE = 'physician';
  DEFAULT_SYNTHESIS_TYPE = 'expert-consensus';
  FHIR_VOID_TAGS = ['area', 'base', 'br', 'col', 'hr', 'img', 'input', 'link', 'meta', 'param'];
  FHIR_NAMED_ENTITIES = {
    '&nbsp;': '&#160;',
    '&mdash;': '&#8212;',
    '&ndash;': '&#8211;',
    '&hellip;': '&#8230;',
    '&bull;': '&#8226;',
    '&ldquo;': '&#8220;',
    '&rdquo;': '&#8221;',
    '&lsquo;': '&#8216;',
    '&rsquo;': '&#8217;',
    '&copy;': '&#169;',
    '&reg;': '&#174;',
    '&trade;': '&#8482;'
  };
  return {
    _getRecommendationType: function() {
      if (mediator.project.get('recommendationsMode') === 'static') {
        return 'ietd';
      } else {
        return 'v1';
      }
    },
    _getQuestionData: function(questionModel) {
      var rawQuestion;
      rawQuestion = _.isFunction(questionModel != null ? questionModel.json : void 0) ? questionModel.json() : _.isFunction(questionModel != null ? questionModel.toJSON : void 0) ? questionModel.toJSON() : questionModel;
      return QuestionDoc.of(rawQuestion).json();
    },
    _jsonldServiceForQuestion: function(questionModel) {
      if (questionModel.isDiagnostic()) {
        return mediator.services.jsonldDiagnosticExport;
      } else {
        return mediator.services.jsonldManagementExport;
      }
    },
    _resolveEntityId: function() {
      var ids;
      ids = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
      return _.find(ids, function(id) {
        return id != null;
      });
    },
    _fallbackRecommendationJsonLd: function(_arg) {
      var id, text, title;
      id = _arg.id, title = _arg.title, text = _arg.text;
      return {
        '@id': id,
        title: title,
        recommendationText: text
      };
    },
    _guidelineSubjectDisplay: function() {
      var _ref, _ref1;
      return (_ref = (_ref1 = mediator.project) != null ? _ref1.get('name') : void 0) != null ? _ref : 'Guideline';
    },
    _buildIdVariants: function(value, guidelineId) {
      var base, tail, withoutGuidelinePrefix;
      base = String(value != null ? value : '').trim();
      if (!(base.length > 0)) {
        return [];
      }
      tail = _.last(_.compact(base.split('/')));
      withoutGuidelinePrefix = base.indexOf("" + guidelineId + "/") === 0 ? base.replace("" + guidelineId + "/", '') : null;
      return _.uniq(_.compact([base, tail, withoutGuidelinePrefix, withoutGuidelinePrefix != null ? _.last(withoutGuidelinePrefix.split('/')) : null, "" + guidelineId + "/" + base]));
    },
    _fhirIdsMatch: function(idA, idB, guidelineId) {
      return _.intersection(this._buildIdVariants(idA, guidelineId), this._buildIdVariants(idB, guidelineId)).length > 0;
    },
    _escapeHtml: function(input) {
      var div;
      if (input == null) {
        input = '';
      }
      div = document.createElement('div');
      div.innerHTML = input;
      return div.textContent;
    },
    _normalizeFhirEntities: function(html) {
      var normalized;
      if (html == null) {
        html = '';
      }
      normalized = String(html);
      _.each(FHIR_NAMED_ENTITIES, function(numeric, entity) {
        return normalized = normalized.split(entity).join(numeric);
      });
      return normalized;
    },
    _selfCloseVoidElements: function(html) {
      var result;
      if (html == null) {
        html = '';
      }
      result = String(html);
      _.each(FHIR_VOID_TAGS, function(tag) {
        return result = result.replace(RegExp("<\\s*" + tag + "((?:\\s+[^>]*)?)\\s*/?>", "gi"), function(match, attrs) {
          var attrsPart;
          if (attrs == null) {
            attrs = '';
          }
          attrsPart = String(attrs).trim();
          if (attrsPart.length > 0) {
            return "<" + tag + " " + attrsPart + "/>";
          } else {
            return "<" + tag + "/>";
          }
        });
      });
      return result;
    },
    _stripDisallowedNarrativeAttributes: function(html) {
      if (html == null) {
        html = '';
      }
      return String(html).replace(/\s+(?:contenteditable|translate|draggable|spellcheck|target|for|data-[\w-]+|aria-[\w-]+|role)(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+))?/gi, '');
    },
    _stripIllegalXmlChars: function(html) {
      if (html == null) {
        html = '';
      }
      return String(html).replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g, '');
    },
    _replaceDisallowedNarrativeElements: function(html) {
      var container, fragment;
      if (html == null) {
        html = '';
      }
      fragment = String(html);
      if (typeof document !== 'undefined') {
        container = document.createElement('div');
        container.innerHTML = fragment;
        _.each(container.querySelectorAll('section,figure,fieldset'), function(el) {
          var div, _ref;
          div = document.createElement('div');
          if (el.hasAttribute('style')) {
            div.setAttribute('style', el.getAttribute('style'));
          }
          div.innerHTML = el.innerHTML;
          return (_ref = el.parentNode) != null ? _ref.replaceChild(div, el) : void 0;
        });
        _.each(container.querySelectorAll('label'), function(label) {
          var span, _ref, _ref1;
          span = document.createElement('span');
          if (label.hasAttribute('style')) {
            span.setAttribute('style', label.getAttribute('style'));
          }
          if (((_ref = label.className) != null ? _ref.length : void 0) > 0) {
            span.className = label.className;
          }
          span.innerHTML = label.innerHTML;
          return (_ref1 = label.parentNode) != null ? _ref1.replaceChild(span, label) : void 0;
        });
        _.each(container.querySelectorAll('[aria-describedby],[role],[name]'), function(el) {
          var _ref;
          if (el.hasAttribute('aria-describedby')) {
            el.removeAttribute('aria-describedby');
          }
          if (el.hasAttribute('role')) {
            el.removeAttribute('role');
          }
          if (el.hasAttribute('name') && ((_ref = el.tagName) != null ? typeof _ref.toLowerCase === "function" ? _ref.toLowerCase() : void 0 : void 0) !== 'a') {
            return el.removeAttribute('name');
          }
        });
        fragment = container.innerHTML;
      } else {
        fragment = fragment.replace(/<\s*(section|figure|fieldset)(\s[^>]*)?>/gi, '<div$2>').replace(/<\s*\/\s*(section|figure|fieldset)\s*>/gi, '</div>').replace(/<\s*label(\s[^>]*)?>/gi, '<span$1>').replace(/<\s*\/\s*label\s*>/gi, '</span>');
      }
      return fragment;
    },
    _prepareFhirNarrativeHtml: function(htmlContent) {
      var fragment;
      if (htmlContent == null) {
        htmlContent = '';
      }
      fragment = this._sanitizeNarrativeHtml(htmlContent);
      if (!(fragment.length > 0)) {
        return '';
      }
      fragment = this._stripIllegalXmlChars(fragment);
      fragment = this._replaceDisallowedNarrativeElements(fragment);
      fragment = this._normalizeFhirEntities(fragment);
      fragment = this._stripDisallowedNarrativeAttributes(fragment);
      return this._selfCloseVoidElements(fragment);
    },
    _toHtmlNarrative: function(htmlContent, fallbackTitle) {
      var inner, sanitized;
      if (htmlContent == null) {
        htmlContent = '';
      }
      if (fallbackTitle == null) {
        fallbackTitle = 'Printout';
      }
      sanitized = this._prepareFhirNarrativeHtml(htmlContent);
      inner = sanitized.length > 0 ? sanitized : this._escapeHtml(fallbackTitle);
      return {
        status: 'generated',
        div: "<div xmlns='http://www.w3.org/1999/xhtml' dir='ltr'>" + inner + "</div>"
      };
    },
    _sectionCodeForType: function(sectionType) {
      switch (sectionType) {
        case 'recommendation':
          return {
            code: 'recommendation-statement',
            display: 'Recommendation Statement'
          };
        default:
          return {
            code: 'text',
            display: 'Text'
          };
      }
    },
    _buildSectionCode: function(_arg) {
      var code, display, system;
      code = _arg.code, display = _arg.display, system = _arg.system;
      if (system == null) {
        system = FEVIR_CODE_SYSTEM;
      }
      return {
        coding: [
          {
            system: system,
            code: code,
            display: display
          }
        ]
      };
    },
    _buildLanguageSubsection: function(htmlContent, fallbackTitle, title) {
      var subsection;
      subsection = {
        extension: [
          {
            url: EXT_SECTION_LANGUAGE,
            valueCode: SECTION_LANGUAGE
          }
        ],
        code: this._buildSectionCode({
          code: 'language',
          display: 'Language',
          system: AWMF_GUIDELINE_SECTIONS_CS
        }),
        text: this._toHtmlNarrative(htmlContent, fallbackTitle)
      };
      if (title != null) {
        subsection.title = title;
      }
      return subsection;
    },
    _wrapSectionWithLanguage: function(_arg) {
      var childSections, entry, extensions, fallbackTitle, htmlContent, languageSection, node, sectionCode, sectionDisplay, sections, title;
      sectionCode = _arg.sectionCode, sectionDisplay = _arg.sectionDisplay, title = _arg.title, entry = _arg.entry, sections = _arg.sections, htmlContent = _arg.htmlContent, fallbackTitle = _arg.fallbackTitle, extensions = _arg.extensions;
      node = {
        code: this._buildSectionCode({
          code: sectionCode,
          display: sectionDisplay
        })
      };
      if ((extensions != null ? extensions.length : void 0) > 0) {
        node.extension = extensions;
      }
      if ((entry != null ? entry.length : void 0) > 0) {
        node.entry = entry;
      }
      languageSection = this._buildLanguageSubsection(htmlContent, fallbackTitle, title);
      childSections = sections != null ? sections : [];
      if (childSections.length > 0) {
        languageSection.section = childSections;
      }
      node.section = [languageSection];
      return node;
    },
    _formatFhirDate: function(isoDateTime) {
      return String(isoDateTime != null ? isoDateTime : new Date().toISOString()).slice(0, 10);
    },
    _extractRecommendationAuthors: function(recommendationJsonLd) {
      var raw, _ref;
      raw = (_ref = recommendationJsonLd != null ? recommendationJsonLd['author'] : void 0) != null ? _ref : recommendationJsonLd != null ? recommendationJsonLd['authors'] : void 0;
      return this._normalizeAuthorCandidates(raw);
    },
    _intendedAudienceSectionExtensions: function(intendedAudienceCode) {
      return [
        {
          url: EXT_SECTION_INTENDED_AUDIENCE,
          valueCodeableConcept: {
            coding: [
              {
                system: AWMF_INTENDED_AUDIENCE_CS,
                code: intendedAudienceCode != null ? intendedAudienceCode : DEFAULT_INTENDED_AUDIENCE
              }
            ]
          }
        }
      ];
    },
    _resolveRecommendationStatementHtml: function(recommendationJsonLd, recommendationHtml) {
      var html, plainText, _ref;
      html = String(recommendationHtml != null ? recommendationHtml : '').trim();
      if (html.length > 0) {
        return html;
      }
      plainText = (_ref = recommendationJsonLd != null ? recommendationJsonLd['recommendationText'] : void 0) != null ? _ref : '';
      return String(plainText).trim();
    },
    _resolveSynthesisTypeCode: function(recommendationJsonLd) {
      var gradingMethod, normalized;
      gradingMethod = this._toSimpleString(recommendationJsonLd != null ? recommendationJsonLd['gradingEvidenceMethod'] : void 0, '');
      normalized = gradingMethod.toLowerCase();
      if (normalized.indexOf('systematic') >= 0 || normalized.indexOf('meta-analysis') >= 0) {
        return 'systematic-review';
      }
      return DEFAULT_SYNTHESIS_TYPE;
    },
    _buildAwmfRecommendationComposition: function(_arg) {
      var authors, bundleMode, compositionAuthors, exportDate, guidelineId, intendedAudienceCode, parentCompositionId, recommendationId, recommendationJsonLd, recommendationTitle, statementCode, statementContent, statementDisplay, statementHtml, statementSection, textSection, title, version, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
      _ref = _arg != null ? _arg : {}, recommendationId = _ref.recommendationId, recommendationJsonLd = _ref.recommendationJsonLd, title = _ref.title, statementHtml = _ref.statementHtml, bundleMode = _ref.bundleMode, intendedAudienceCode = _ref.intendedAudienceCode;
      if (recommendationId == null) {
        recommendationId = (_ref1 = recommendationJsonLd != null ? recommendationJsonLd['@id'] : void 0) != null ? _ref1 : 'recommendation';
      }
      recommendationTitle = String((_ref2 = title != null ? title : recommendationJsonLd != null ? recommendationJsonLd['title'] : void 0) != null ? _ref2 : '').trim() || 'Recommendation';
      version = String((_ref3 = recommendationJsonLd != null ? recommendationJsonLd['version'] : void 0) != null ? _ref3 : '1.0').trim() || '1.0';
      statementContent = this._resolveRecommendationStatementHtml(recommendationJsonLd, statementHtml);
      guidelineId = (_ref4 = (_ref5 = mediator.project) != null ? _ref5.id : void 0) != null ? _ref4 : 'guideline';
      parentCompositionId = this._makeFhirId(guidelineId, bundleMode != null ? bundleMode : 'documentSections', 'composition');
      exportDate = new Date().toISOString();
      authors = this._extractRecommendationAuthors(recommendationJsonLd);
      compositionAuthors = this._resolveGuidelineAuthors({
        authors: authors
      }, recommendationTitle);
      textSection = this._wrapSectionWithLanguage({
        sectionCode: 'text',
        sectionDisplay: 'Text',
        title: recommendationTitle,
        htmlContent: recommendationTitle,
        fallbackTitle: recommendationTitle,
        extensions: this._intendedAudienceSectionExtensions(intendedAudienceCode)
      });
      _ref6 = this._sectionCodeForType('recommendation'), statementCode = _ref6.code, statementDisplay = _ref6.display;
      statementSection = {
        code: this._buildSectionCode({
          code: statementCode,
          display: statementDisplay
        }),
        text: this._toHtmlNarrative(statementContent, recommendationTitle)
      };
      return {
        resourceType: 'Composition',
        id: this._makeFhirId(recommendationId, 'recommendation'),
        meta: {
          profile: [AWMF_RECOMMENDATION_PROFILE]
        },
        text: this._toHtmlNarrative(recommendationTitle, recommendationTitle),
        identifier: [
          {
            use: 'official',
            system: AWMF_RECOMMENDATION_IDENTIFIER_SYSTEM,
            value: String(recommendationId)
          }
        ],
        version: version,
        status: 'final',
        type: {
          coding: [
            {
              system: FEVIR_CODE_SYSTEM,
              code: 'Recommendation',
              display: 'Recommendation'
            }
          ]
        },
        category: [
          {
            coding: [
              {
                system: AWMF_RECOMMENDATION_SYNTHESIS_CS,
                code: this._resolveSynthesisTypeCode(recommendationJsonLd)
              }
            ]
          }
        ],
        date: this._formatFhirDate(exportDate),
        author: compositionAuthors,
        title: recommendationTitle,
        relatesTo: [
          {
            type: 'part-of',
            targetCanonical: "" + AWMF_IG_CANONICAL_BASE + "/Composition/" + parentCompositionId
          }
        ],
        section: [textSection, statementSection]
      };
    },
    _sanitizeNarrativeHtml: function(htmlContent) {
      var bodyMatch, fragment, html;
      if (htmlContent == null) {
        htmlContent = '';
      }
      html = String(htmlContent != null ? htmlContent : '');
      bodyMatch = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
      fragment = (bodyMatch != null ? bodyMatch[1] : void 0) != null ? bodyMatch[1] : html;
      return fragment.replace(/<!DOCTYPE[\s\S]*?>/gi, '').replace(/<\?xml[\s\S]*?\?>/gi, '').replace(/<\/?(html|head|body|meta|link|title|script|style)[^>]*>/gi, '').replace(/\s+xmlns="[^"]*"/gi, '').trim();
    },
    _toBase64: function(raw) {
      var normalized;
      if (raw == null) {
        raw = '';
      }
      normalized = String(raw != null ? raw : '');
      if (typeof btoa === 'function') {
        return btoa(unescape(encodeURIComponent(normalized)));
      } else if (typeof Buffer !== 'undefined') {
        return Buffer.from(normalized, 'utf8').toString('base64');
      } else {
        return '';
      }
    },
    _toSimpleString: function(value, fallback) {
      var candidate, firstNested, firstNonEmpty, key, preferredKeys, _i, _len;
      if (fallback == null) {
        fallback = '';
      }
      if (_.isString(value)) {
        return value.trim();
      }
      if (_.isNumber(value) || _.isBoolean(value)) {
        return String(value);
      }
      if (_.isArray(value)) {
        firstNonEmpty = _.chain(value).map((function(_this) {
          return function(item) {
            return _this._toSimpleString(item, '');
          };
        })(this)).find(function(item) {
          return item.length > 0;
        }).value();
        return firstNonEmpty != null ? firstNonEmpty : fallback;
      }
      if (_.isObject(value)) {
        preferredKeys = ['name', 'title', 'label', 'value', '@value', 'text'];
        for (_i = 0, _len = preferredKeys.length; _i < _len; _i++) {
          key = preferredKeys[_i];
          candidate = this._toSimpleString(value[key], '');
          if (candidate.length > 0) {
            return candidate;
          }
        }
        firstNested = _.chain(value).values().map((function(_this) {
          return function(item) {
            return _this._toSimpleString(item, '');
          };
        })(this)).find(function(item) {
          return item.length > 0;
        }).value();
        return firstNested != null ? firstNested : fallback;
      }
      return fallback;
    },
    _applyResourceDate: function(resource, exportDate) {
      if (resource.meta == null) {
        resource.meta = {};
      }
      resource.meta.lastUpdated = exportDate;
      return resource;
    },
    _sanitizeFhirIdPart: function(value) {
      if (value == null) {
        value = '';
      }
      return String(value).toLowerCase().replace(/[^a-z0-9\-.]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
    },
    _makeFhirId: function() {
      var parts, raw;
      parts = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
      raw = _.chain(parts).flatten().compact().map((function(_this) {
        return function(part) {
          return _this._sanitizeFhirIdPart(part);
        };
      })(this)).filter(function(part) {
        return part.length > 0;
      }).join('-').value();
      if (raw.length === 0) {
        raw = 'resource';
      }
      return raw.slice(0, 64);
    },
    _buildAttachmentEntry: function(_arg) {
      var attachment, content, contentType, encodedData, profile, subjectDisplay, title, uuid;
      title = _arg.title, content = _arg.content, contentType = _arg.contentType, profile = _arg.profile, subjectDisplay = _arg.subjectDisplay;
      uuid = generateGUID();
      encodedData = this._toBase64(content);
      attachment = {
        contentType: contentType,
        title: title
      };
      if (encodedData.length > 0) {
        attachment.data = encodedData;
      }
      return {
        uuid: uuid,
        resource: {
          resourceType: 'DocumentReference',
          id: this._makeFhirId(title, uuid),
          meta: {
            profile: profile ? [profile] : void 0
          },
          status: 'current',
          description: title,
          text: {
            status: 'generated',
            div: "<div xmlns='http://www.w3.org/1999/xhtml'><p>" + (this._escapeHtml(title)) + "</p></div>"
          },
          subject: subjectDisplay ? {
            display: subjectDisplay
          } : void 0,
          content: [
            {
              attachment: attachment
            }
          ]
        }
      };
    },
    _buildTypedAttachment: function(_arg) {
      var content, contentType, label, profile, subjectDisplay, titleBase;
      titleBase = _arg.titleBase, label = _arg.label, content = _arg.content, contentType = _arg.contentType, subjectDisplay = _arg.subjectDisplay, profile = _arg.profile;
      return this._buildAttachmentEntry({
        title: "" + titleBase + " - " + label,
        content: content,
        contentType: contentType,
        subjectDisplay: subjectDisplay,
        profile: profile
      });
    },
    _addLabeledAttachment: function(_arg) {
      var attachment, content, contentType, label, normalizedContent, refs, requireContent, resources, subjectDisplay, titleBase;
      resources = _arg.resources, refs = _arg.refs, titleBase = _arg.titleBase, label = _arg.label, content = _arg.content, contentType = _arg.contentType, subjectDisplay = _arg.subjectDisplay, requireContent = _arg.requireContent;
      if (requireContent == null) {
        requireContent = true;
      }
      normalizedContent = String(content != null ? content : '');
      if (requireContent) {
        normalizedContent = normalizedContent.trim();
        if (!(normalizedContent.length > 0)) {
          return null;
        }
      }
      attachment = this._buildTypedAttachment({
        titleBase: titleBase,
        label: label,
        content: normalizedContent,
        contentType: contentType,
        subjectDisplay: subjectDisplay
      });
      if (resources != null) {
        resources.push(attachment);
      }
      if (refs != null) {
        refs.push("urn:uuid:" + attachment.uuid);
      }
      return attachment;
    },
    _appendSectionRefs: function(map, sectionId, newRefs) {
      if (newRefs == null) {
        newRefs = [];
      }
      if (map[sectionId] == null) {
        map[sectionId] = [];
      }
      map[sectionId] = _.uniq(map[sectionId].concat(newRefs));
      return map;
    },
    _normalizeAuthorCandidates: function(value) {
      var collect, normalized;
      normalized = [];
      collect = (function(_this) {
        return function(candidate) {
          var splitBySemicolon, text, textValue;
          if (_.isArray(candidate)) {
            _.each(candidate, function(nested) {
              return collect(nested);
            });
            return;
          }
          if (_.isObject(candidate)) {
            textValue = _this._toSimpleString(candidate, '');
            if (textValue.length > 0) {
              collect(textValue);
            }
            return;
          }
          text = _this._toSimpleString(candidate, '');
          if (!(text.length > 0)) {
            return;
          }
          splitBySemicolon = _.chain(text.split(';')).map(function(part) {
            return String(part != null ? part : '').trim();
          }).filter(function(part) {
            return part.length > 0;
          }).value();
          if (splitBySemicolon.length > 1) {
            return normalized.push.apply(normalized, splitBySemicolon);
          } else {
            return normalized.push(text);
          }
        };
      })(this);
      collect(value);
      return _.uniq(_.compact(normalized));
    },
    _resolveGuidelineAuthors: function(guideline, guidelineTitle) {
      var authors, filtered, normalizedCandidates, rawCandidates, _ref, _ref1;
      rawCandidates = _.compact([guideline != null ? guideline.authors : void 0, guideline != null ? guideline.author : void 0, guideline != null ? guideline.byName : void 0, guideline != null ? guideline.institutionName : void 0, guideline != null ? guideline.owner : void 0, (_ref = mediator.project) != null ? _ref.get('authors') : void 0, (_ref1 = mediator.project) != null ? _ref1.get('owner') : void 0]);
      normalizedCandidates = _.chain(rawCandidates).map((function(_this) {
        return function(candidate) {
          return _this._normalizeAuthorCandidates(candidate);
        };
      })(this)).flatten().map(function(candidate) {
        return String(candidate != null ? candidate : '').trim();
      }).filter(function(candidate) {
        return candidate.length > 0;
      }).uniq().value();
      filtered = _.filter(normalizedCandidates, function(candidate) {
        return candidate !== guidelineTitle;
      });
      authors = _.map(filtered, function(display) {
        return {
          display: display
        };
      });
      if (authors.length === 0) {
        return [
          {
            display: 'Unknown author'
          }
        ];
      } else {
        return authors;
      }
    },
    _resolveRecommendationPrintoutOptions: function(recommendationId, questionModel) {
      if (recommendationId == null) {
        return W.resolve({
          etdViewMode: 'ALL-draftJudgement'
        });
      }
      return W.promise((function(_this) {
        return function(resolve) {
          var callbackId, cleanedUp, cleanup, downstreamActionsMap, downstreamFetches, resolveDefault, resolveFromStores, watchdog;
          downstreamFetches = {
            etd: true,
            references: true,
            voting: true,
            questions: true
          };
          downstreamActionsMap = {
            'EtdActions.fetchSuccess': 'etd',
            'ReferencesActions.fetchSuccess': 'references',
            'ReferencesActions.fetchError': 'references',
            'EtdVotingActions.fetchSuccess': 'voting',
            'EtdVotingActions.fetchError': 'voting',
            'QuestionsActions.fetchSuccess': 'questions',
            'QuestionsActions.fetchError': 'questions'
          };
          cleanedUp = false;
          watchdog = null;
          cleanup = function() {
            if (cleanedUp) {
              return;
            }
            cleanedUp = true;
            if (typeof callbackId !== "undefined" && callbackId !== null) {
              alt.dispatcher.unregister(callbackId);
            }
            if (watchdog != null) {
              return clearTimeout(watchdog);
            }
          };
          resolveDefault = function() {
            cleanup();
            return resolve({
              etdViewMode: 'ALL-draftJudgement'
            });
          };
          resolveFromStores = function() {
            var options;
            cleanup();
            options = EtdVotingStore.getVotingData().isEmpty() ? {
              etdViewMode: 'ALL-draftJudgement'
            } : {
              etdViewMode: 'judgements-consensus#recommendation-consensus#conclusions-proposed',
              showVotingResults: false
            };
            return resolve(options);
          };
          callbackId = alt.dispatcher.register(function(payload) {
            var actionName, storeKey;
            actionName = payload != null ? payload.action : void 0;
            if (actionName === 'EtdActions.fetchError') {
              resolveDefault();
              return;
            }
            storeKey = downstreamActionsMap[actionName];
            if (storeKey == null) {
              return;
            }
            downstreamFetches[storeKey] = false;
            if (_.any(_(downstreamFetches).values())) {
              return;
            }
            return mediator.services.presentationService.getEtdPresentationData(recommendationId, questionModel, 'clinicians').then(resolveFromStores)["catch"](resolveDefault);
          });
          watchdog = setTimeout(resolveDefault, 8000);
          return EtdActions.fetch({
            dbId: mediator.project.id,
            docId: [recommendationId]
          });
        };
      })(this));
    },
    _fetchRegularQuestionArtifacts: function(questionId, recommendationId) {
      if (!((questionId != null) && (recommendationId != null))) {
        return W.resolve(null);
      }
      return QuestionDoc.at(mediator.project.id, questionId).fetch().then((function(_this) {
        return function(questionDoc) {
          var jsonldService, questionData, questionModel;
          questionModel = new Question(questionDoc);
          questionData = _this._getQuestionData(questionModel);
          jsonldService = _this._jsonldServiceForQuestion(questionModel);
          return _this._resolveRecommendationPrintoutOptions(recommendationId, questionModel).then(function(printoutOptions) {
            var recommendationExport;
            recommendationExport = new HtmlExport(questionModel, 'recommendations-v2', printoutOptions != null ? printoutOptions : {});
            return W.all([jsonldService["export"](questionData, _this._getRecommendationType()), recommendationExport.getSource()]);
          });
        };
      })(this)).then(function(_arg) {
        var questionJsonLd, recommendationHtml, recommendationJsonLd, _ref;
        (_ref = _arg[0], questionJsonLd = _ref[0], recommendationJsonLd = _ref[1]), recommendationHtml = _arg[1];
        return {
          questionJsonLd: questionJsonLd,
          recommendationJsonLd: recommendationJsonLd,
          recommendationHtml: recommendationHtml
        };
      })["catch"](function() {
        return null;
      });
    },
    _prependRecommendationComposition: function(_arg) {
      var alwaysInclude, bundleMode, entry, hasRecommendationJsonLd, placement, recommendationId, recommendationJsonLd, refs, resources, shouldInclude, statementHtml, title;
      resources = _arg.resources, refs = _arg.refs, recommendationId = _arg.recommendationId, recommendationJsonLd = _arg.recommendationJsonLd, title = _arg.title, statementHtml = _arg.statementHtml, bundleMode = _arg.bundleMode, hasRecommendationJsonLd = _arg.hasRecommendationJsonLd, placement = _arg.placement, alwaysInclude = _arg.alwaysInclude;
      if (placement == null) {
        placement = 'prepend';
      }
      shouldInclude = alwaysInclude || String(statementHtml != null ? statementHtml : '').trim().length > 0 || hasRecommendationJsonLd;
      if (!shouldInclude) {
        return null;
      }
      entry = {
        uuid: generateGUID(),
        resource: this._buildAwmfRecommendationComposition({
          recommendationId: recommendationId,
          recommendationJsonLd: recommendationJsonLd,
          title: title,
          statementHtml: statementHtml,
          bundleMode: bundleMode
        })
      };
      if (placement === 'prepend') {
        resources.unshift(entry);
        if (refs != null) {
          refs.unshift("urn:uuid:" + entry.uuid);
        }
      } else {
        resources.push(entry);
      }
      return entry;
    },
    _buildEmbeddedRecommendationAttachments: function(section, sectionTitle, subjectDisplay) {
      var addAttachment, questionId, recommendationId, recommendationPrintout, refs, resources, sectionId, sofPrintout, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
      sectionId = section != null ? section.id : void 0;
      refs = [];
      resources = [];
      addAttachment = (function(_this) {
        return function(label, content, contentType) {
          return _this._addLabeledAttachment({
            resources: resources,
            refs: refs,
            titleBase: sectionTitle,
            label: label,
            content: content,
            contentType: contentType,
            subjectDisplay: subjectDisplay
          });
        };
      })(this);
      sofPrintout = section != null ? (_ref = section.recommendationData) != null ? _ref.sofPrintout : void 0 : void 0;
      recommendationPrintout = (_ref1 = section != null ? (_ref2 = section.recommendationData) != null ? (_ref3 = _ref2.dart) != null ? _ref3.recommendationText : void 0 : void 0 : void 0) != null ? _ref1 : section != null ? section.htmlContent : void 0;
      questionId = section != null ? (_ref4 = section.recommendationData) != null ? _ref4.questionId : void 0 : void 0;
      recommendationId = section != null ? (_ref5 = section.recommendationData) != null ? _ref5.recommendationId : void 0 : void 0;
      return this._fetchRegularQuestionArtifacts(questionId, recommendationId).then((function(_this) {
        return function(regularArtifacts) {
          var entityId, recommendationJsonLd, _ref6, _ref7;
          entityId = _this._resolveEntityId(recommendationId, questionId, sectionId);
          if ((regularArtifacts != null ? regularArtifacts.questionJsonLd : void 0) != null) {
            addAttachment('Table JSON-LD', JSON.stringify(regularArtifacts.questionJsonLd, null, 2), 'application/ld+json');
          }
          if ((regularArtifacts != null ? regularArtifacts.recommendationJsonLd : void 0) != null) {
            addAttachment('Recommendation JSON-LD', JSON.stringify(regularArtifacts.recommendationJsonLd, null, 2), 'application/ld+json');
          }
          recommendationPrintout = (_ref6 = regularArtifacts != null ? regularArtifacts.recommendationHtml : void 0) != null ? _ref6 : recommendationPrintout;
          recommendationJsonLd = (_ref7 = regularArtifacts != null ? regularArtifacts.recommendationJsonLd : void 0) != null ? _ref7 : _this._fallbackRecommendationJsonLd({
            id: entityId,
            title: sectionTitle,
            text: recommendationPrintout
          });
          _this._prependRecommendationComposition({
            resources: resources,
            refs: refs,
            recommendationId: entityId,
            recommendationJsonLd: recommendationJsonLd,
            title: sectionTitle,
            statementHtml: recommendationPrintout,
            bundleMode: 'documentSections',
            hasRecommendationJsonLd: !!(regularArtifacts != null ? regularArtifacts.recommendationJsonLd : void 0)
          });
          addAttachment('SoF Printout', sofPrintout, 'text/html');
          addAttachment('Recommendation Printout', recommendationPrintout, 'text/html');
          return {
            sectionId: sectionId,
            refs: refs,
            resources: resources
          };
        };
      })(this));
    },
    _getSofPrintoutTypeForQuestion: function(questionModel) {
      var preferredView, viewName, _ref, _ref1;
      preferredView = (_ref = mediator.services.esView) != null ? typeof _ref.getPreferredType === "function" ? _ref.getPreferredType(mediator.project, questionModel.get('type')) : void 0 : void 0;
      viewName = preferredView != null ? preferredView.name : void 0;
      return (_ref1 = QUESTION_VIEW_NAME_TO_PRINTOUT_TYPE[viewName]) != null ? _ref1 : 'sof';
    },
    _extractSectionPrintoutHtml: function(section) {
      var htmlCandidates, resolved, _ref, _ref1, _ref2, _ref3;
      if (section == null) {
        return '';
      }
      htmlCandidates = [section != null ? section.htmlContent : void 0, section != null ? (_ref = section.recommendationData) != null ? _ref.sofPrintout : void 0 : void 0, section != null ? (_ref1 = section.recommendationData) != null ? (_ref2 = _ref1.dart) != null ? _ref2.recommendationText : void 0 : void 0 : void 0, section != null ? (_ref3 = section.tableData) != null ? _ref3.htmlContent : void 0 : void 0];
      resolved = _.find(htmlCandidates, function(candidate) {
        return _.isString(candidate) && candidate.trim().length > 0;
      });
      return resolved != null ? resolved : '';
    },
    _buildQuestionArtifacts: function(questionModel) {
      var recommendationExport, sofExport, sofPrintoutType;
      sofPrintoutType = this._getSofPrintoutTypeForQuestion(questionModel);
      sofExport = new HtmlExport(questionModel, sofPrintoutType, {});
      recommendationExport = new HtmlExport(questionModel, 'recommendations-v2', {
        etdViewMode: 'ALL-draftJudgement'
      });
      return W.all([sofExport.getSource(), recommendationExport.getSource()]).then(function(_arg) {
        var recommendationHtml, sofHtml;
        sofHtml = _arg[0], recommendationHtml = _arg[1];
        return {
          sofHtml: sofHtml,
          recommendationHtml: recommendationHtml
        };
      });
    },
    _buildBundle: function(mode, entries, _arg) {
      var bundleId, compositionId, compositionProfile, compositionSections, compositionUuid, datedEntries, exportDate, guideline, guidelineAuthors, guidelineId, guidelineTitle, _ref, _ref1, _ref2, _ref3;
      guideline = (_arg != null ? _arg : {}).guideline;
      guidelineId = (_ref = (_ref1 = mediator.project) != null ? _ref1.id : void 0) != null ? _ref : 'unknown-guideline';
      guidelineTitle = (_ref2 = (_ref3 = mediator.project) != null ? _ref3.get('name') : void 0) != null ? _ref2 : 'Guideline';
      guidelineAuthors = this._resolveGuidelineAuthors(guideline, guidelineTitle);
      exportDate = new Date().toISOString();
      bundleId = this._makeFhirId(guidelineId, mode, 'bundle');
      compositionId = this._makeFhirId(guidelineId, mode, 'composition');
      compositionUuid = generateGUID();
      datedEntries = _.map(entries, (function(_this) {
        return function(entry) {
          var resource, uuid, _ref4, _ref5;
          uuid = (_ref4 = entry != null ? entry.uuid : void 0) != null ? _ref4 : generateGUID();
          resource = (_ref5 = entry != null ? entry.resource : void 0) != null ? _ref5 : {};
          if (resource.id == null) {
            resource.id = _this._makeFhirId(resource.resourceType, uuid);
          }
          return {
            fullUrl: "urn:uuid:" + uuid,
            uuid: uuid,
            resource: _this._applyResourceDate(resource, exportDate)
          };
        };
      })(this));
      compositionSections = _.map(datedEntries, function(_arg1) {
        var fullUrl, resource, sectionTitle, _ref4, _ref5;
        fullUrl = _arg1.fullUrl, resource = _arg1.resource;
        sectionTitle = (_ref4 = (_ref5 = resource != null ? resource.title : void 0) != null ? _ref5 : resource != null ? resource.name : void 0) != null ? _ref4 : resource != null ? resource.resourceType : void 0;
        return {
          title: sectionTitle,
          entry: [
            {
              reference: fullUrl
            }
          ]
        };
      });
      compositionProfile = mode === 'documentSections' ? AWMF_GUIDELINE_PROFILE : EBM_GUIDELINE_PROFILE;
      return {
        resourceType: 'Bundle',
        id: bundleId,
        type: 'collection',
        timestamp: exportDate,
        identifier: {
          system: 'urn:ietf:rfc:3986',
          value: "urn:uuid:" + (generateGUID())
        },
        language: 'en',
        implicitRules: IG_DISSOLVE_E,
        meta: {
          profile: ["" + DISSOLVE_CANONICAL_BASE + "/guideline-registry-bundle"],
          tag: [
            {
              system: 'urn:ietf:rfc:3986',
              code: IG_DISSOLVE_E,
              display: 'Dissolve-E IG'
            }, {
              system: 'urn:ietf:rfc:3986',
              code: IG_EBM_ON_FHIR,
              display: 'EBM-on-FHIR IG'
            }, {
              system: 'urn:ietf:rfc:3986',
              code: IG_FHIR_BASE,
              display: 'FHIR base specification'
            }
          ]
        },
        entry: [
          {
            fullUrl: "urn:uuid:" + compositionUuid,
            resource: {
              resourceType: 'Composition',
              id: compositionId,
              meta: {
                profile: [compositionProfile],
                lastUpdated: exportDate
              },
              status: 'final',
              title: "" + guidelineTitle + " - " + mode,
              date: exportDate,
              type: {
                coding: [
                  {
                    system: FEVIR_CODE_SYSTEM,
                    code: 'Guideline',
                    display: 'Guideline'
                  }
                ],
                text: 'Guideline'
              },
              subject: [
                {
                  display: guidelineTitle
                }
              ],
              author: guidelineAuthors,
              text: {
                status: 'generated',
                div: "<div xmlns='http://www.w3.org/1999/xhtml'>" + (this._escapeHtml(guidelineTitle)) + "</div>"
              },
              section: compositionSections
            }
          }
        ].concat(_.map(datedEntries, function(_arg1) {
          var fullUrl, resource;
          fullUrl = _arg1.fullUrl, resource = _arg1.resource;
          return {
            fullUrl: fullUrl,
            resource: resource
          };
        }))
      };
    },
    _buildDocumentSectionsResources: function(_arg) {
      var attachmentRefsBySectionId, resources, sections, subjectDisplay;
      sections = _arg.sections;
      resources = [];
      attachmentRefsBySectionId = {};
      subjectDisplay = this._guidelineSubjectDisplay();
      return W.reduce(sections != null ? sections : [], ((function(_this) {
        return function(_acc, section, idx) {
          var printoutHtml, sectionId, sectionRefs, sectionTitle, tableJson, tableJsonAttachment, tablePrintoutAttachment, _ref, _ref1, _ref2, _ref3;
          sectionId = (_ref = section != null ? section.id : void 0) != null ? _ref : "section-" + (idx + 1);
          sectionTitle = section != null ? section.title : void 0;
          if (attachmentRefsBySectionId[sectionId] == null) {
            attachmentRefsBySectionId[sectionId] = [];
          }
          if ((section != null ? section.type : void 0) === 'recommendation') {
            return _this._buildEmbeddedRecommendationAttachments(section, sectionTitle, subjectDisplay).then(function(embedded) {
              resources.push.apply(resources, embedded.resources);
              return _this._appendSectionRefs(attachmentRefsBySectionId, sectionId, embedded.refs);
            });
          } else {
            sectionRefs = [];
            if ((_ref1 = section != null ? section.type : void 0) === 'table' || _ref1 === 'mdaTable') {
              tableJson = (_ref2 = section != null ? (_ref3 = section.tableData) != null ? _ref3.table : void 0 : void 0) != null ? _ref2 : {};
              tableJsonAttachment = _this._buildTypedAttachment({
                titleBase: sectionTitle,
                label: 'Table JSON-LD',
                content: JSON.stringify(tableJson, null, 2),
                contentType: 'application/ld+json',
                subjectDisplay: subjectDisplay
              });
              resources.push(tableJsonAttachment);
              sectionRefs.push("urn:uuid:" + tableJsonAttachment.uuid);
              printoutHtml = _this._extractSectionPrintoutHtml(section);
              if (String(printoutHtml != null ? printoutHtml : '').trim().length > 0) {
                tablePrintoutAttachment = _this._buildTypedAttachment({
                  titleBase: sectionTitle,
                  label: 'Table Printout',
                  content: printoutHtml,
                  contentType: 'text/html',
                  subjectDisplay: subjectDisplay
                });
                resources.push(tablePrintoutAttachment);
                sectionRefs.push("urn:uuid:" + tablePrintoutAttachment.uuid);
              }
            }
            _this._appendSectionRefs(attachmentRefsBySectionId, sectionId, sectionRefs);
            return W.resolve();
          }
        };
      })(this)), null).then(function() {
        return {
          resources: resources,
          attachmentRefsBySectionId: attachmentRefsBySectionId
        };
      });
    },
    _buildBookSectionTree: function(_arg) {
      var attachmentRefsBySectionId, buildChapterNode, chapterById, chapterList, chapters, guideline, guidelineId, idVariants, idsMatch, resolveChapter, resolveSectionForChapter, rootChapterIds, sectionBelongsToChapter, sectionList, sectionNode, sections, sectionsByGuid, sectionsById, _ref, _ref1, _ref2, _ref3;
      guideline = _arg.guideline, chapters = _arg.chapters, sections = _arg.sections, attachmentRefsBySectionId = _arg.attachmentRefsBySectionId;
      guidelineId = (_ref = (_ref1 = guideline != null ? guideline.id : void 0) != null ? _ref1 : (_ref2 = mediator.project) != null ? _ref2.id : void 0) != null ? _ref : 'guideline';
      chapterById = _.indexBy(chapters != null ? chapters : [], function(chapter) {
        return chapter != null ? chapter.id : void 0;
      });
      sectionsByGuid = _.indexBy(sections != null ? sections : [], function(section) {
        return section != null ? section.guid : void 0;
      });
      sectionsById = _.indexBy(sections != null ? sections : [], function(section) {
        return section != null ? section.id : void 0;
      });
      chapterList = chapters != null ? chapters : [];
      sectionList = sections != null ? sections : [];
      idVariants = (function(_this) {
        return function(value) {
          return _this._buildIdVariants(value, guidelineId);
        };
      })(this);
      idsMatch = (function(_this) {
        return function(idA, idB) {
          return _this._fhirIdsMatch(idA, idB, guidelineId);
        };
      })(this);
      resolveChapter = function(chapterId, parentChapterId) {
        var candidates, exact, normalized;
        if (parentChapterId == null) {
          parentChapterId = null;
        }
        candidates = _.uniq(_.compact([chapterId, "" + guidelineId + "/" + chapterId, parentChapterId ? "" + parentChapterId + "/" + chapterId : null]));
        exact = _.find(candidates, function(id) {
          return chapterById[id] != null;
        });
        if (exact != null) {
          return chapterById[exact];
        }
        normalized = _.find(chapterList, function(chapter) {
          return _.some(candidates, function(candidateId) {
            return idsMatch(chapter != null ? chapter.id : void 0, candidateId);
          });
        });
        return normalized != null ? normalized : null;
      };
      sectionNode = (function(_this) {
        return function(section) {
          var code, display, entry, fallbackTitle, hasCompositionRef, htmlContent, refs, sectionId, _ref3, _ref4, _ref5, _ref6;
          sectionId = section != null ? section.id : void 0;
          refs = [];
          refs = refs.concat((_ref3 = attachmentRefsBySectionId[sectionId]) != null ? _ref3 : []);
          _ref4 = _this._sectionCodeForType(section != null ? section.type : void 0), code = _ref4.code, display = _ref4.display;
          hasCompositionRef = (section != null ? section.type : void 0) === 'recommendation' && refs.length > 0;
          htmlContent = hasCompositionRef ? (_ref5 = section != null ? section.title : void 0) != null ? _ref5 : '' : _this._extractSectionPrintoutHtml(section);
          fallbackTitle = (_ref6 = section != null ? section.title : void 0) != null ? _ref6 : 'Section';
          entry = refs.length > 0 ? _.map(refs, function(ref) {
            return {
              reference: ref
            };
          }) : void 0;
          return _this._wrapSectionWithLanguage({
            sectionCode: code,
            sectionDisplay: display,
            title: section != null ? section.title : void 0,
            entry: entry,
            htmlContent: htmlContent,
            fallbackTitle: fallbackTitle
          });
        };
      })(this);
      sectionBelongsToChapter = function(section, chapterId) {
        return idsMatch(section != null ? section.chapterId : void 0, chapterId);
      };
      resolveSectionForChapter = function(chapterId, sectionRef) {
        var chapterSections, sectionByGuid, sectionByIdValue, targetVariants;
        chapterSections = _.filter(sectionList, function(section) {
          return sectionBelongsToChapter(section, chapterId);
        });
        sectionByGuid = sectionsByGuid[sectionRef];
        if ((sectionByGuid != null) && sectionBelongsToChapter(sectionByGuid, chapterId)) {
          return sectionByGuid;
        }
        sectionByIdValue = sectionsById[sectionRef];
        if ((sectionByIdValue != null) && sectionBelongsToChapter(sectionByIdValue, chapterId)) {
          return sectionByIdValue;
        }
        targetVariants = idVariants(sectionRef);
        return _.find(chapterSections, function(section) {
          var sectionVariants;
          sectionVariants = _.uniq(_.flatten([idVariants(section != null ? section.guid : void 0), idVariants(section != null ? section.id : void 0)]));
          return _.intersection(sectionVariants, targetVariants).length > 0;
        });
      };
      buildChapterNode = (function(_this) {
        return function(chapter) {
          var chapterChildren, chapterId, chapterSections, chapterSectionsByMembership, chapterTitle, ordered, presentSectionIds, remaining, resolvedSubchapters, subchapterNodes, _ref3, _ref4, _ref5;
          chapterId = chapter != null ? chapter.id : void 0;
          chapterSectionsByMembership = _.filter(sectionList, function(section) {
            return sectionBelongsToChapter(section, chapterId);
          });
          chapterSections = _.isArray(chapter != null ? chapter.sections : void 0) && chapter.sections.length > 0 ? (ordered = _.chain(chapter.sections).map(function(sectionRef) {
            return resolveSectionForChapter(chapterId, sectionRef);
          }).compact().value(), presentSectionIds = _.chain(ordered).pluck('id').compact().value(), remaining = _.filter(chapterSectionsByMembership, function(section) {
            return !_.contains(presentSectionIds, section != null ? section.id : void 0);
          }), ordered.concat(remaining)) : chapterSectionsByMembership;
          chapterSections = _.map(chapterSections, function(section) {
            return sectionNode(section);
          });
          resolvedSubchapters = _.chain((_ref3 = chapter != null ? chapter.subchapters : void 0) != null ? _ref3 : []).map(function(subchapterId) {
            return resolveChapter(subchapterId, chapterId);
          }).map(function(resolvedChapter) {
            return resolvedChapter != null ? resolvedChapter.id : void 0;
          }).compact().value();
          subchapterNodes = _.chain(resolvedSubchapters).map(function(subchapterId) {
            return chapterById[subchapterId];
          }).compact().map(function(subchapter) {
            return buildChapterNode(subchapter);
          }).value();
          chapterChildren = chapterSections.concat(subchapterNodes);
          chapterTitle = (_ref4 = (_ref5 = chapter != null ? chapter.title : void 0) != null ? _ref5 : chapterId) != null ? _ref4 : 'Chapter';
          return _this._wrapSectionWithLanguage({
            sectionCode: 'text',
            sectionDisplay: 'Text',
            title: chapterTitle,
            htmlContent: '',
            fallbackTitle: chapterTitle,
            sections: chapterChildren
          });
        };
      })(this);
      rootChapterIds = _.chain((_ref3 = guideline != null ? guideline.chapters : void 0) != null ? _ref3 : []).map((function(_this) {
        return function(chapterId) {
          var _ref3;
          return (_ref3 = resolveChapter(chapterId)) != null ? _ref3.id : void 0;
        };
      })(this)).compact().value();
      return _.chain(rootChapterIds).map(function(chapterId) {
        return chapterById[chapterId];
      }).compact().map(function(chapter) {
        return buildChapterNode(chapter);
      }).value();
    },
    _buildQuestionResources: function(questionJsonLd, recommendationJsonLd, artifacts) {
      var addAttachment, attachmentResources, jsonLdQuestion, jsonLdRecommendation, questionId, questionResourceId, questionTitle, questionUuid, recommendationHtml, recommendationPayload, recommendationTitle, result, sofHtml, subjectDisplay, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
      if (artifacts == null) {
        artifacts = {};
      }
      questionId = (_ref = (_ref1 = questionJsonLd != null ? questionJsonLd['@id'] : void 0) != null ? _ref1 : questionJsonLd != null ? questionJsonLd.identifier : void 0) != null ? _ref : 'question';
      questionTitle = String((_ref2 = questionJsonLd != null ? questionJsonLd.title : void 0) != null ? _ref2 : '').trim() || 'Question';
      questionResourceId = this._makeFhirId(questionId, 'question');
      questionUuid = generateGUID();
      recommendationTitle = String((_ref3 = recommendationJsonLd != null ? recommendationJsonLd.title : void 0) != null ? _ref3 : '').trim() || 'Recommendation';
      subjectDisplay = this._guidelineSubjectDisplay();
      jsonLdQuestion = JSON.stringify(questionJsonLd != null ? questionJsonLd : {}, null, 2);
      jsonLdRecommendation = JSON.stringify(recommendationJsonLd != null ? recommendationJsonLd : {}, null, 2);
      sofHtml = (_ref4 = artifacts != null ? artifacts.sofHtml : void 0) != null ? _ref4 : '';
      recommendationHtml = (_ref5 = artifacts != null ? artifacts.recommendationHtml : void 0) != null ? _ref5 : '';
      attachmentResources = [];
      addAttachment = (function(_this) {
        return function(titleBase, label, content, contentType) {
          return _this._addLabeledAttachment({
            resources: attachmentResources,
            titleBase: titleBase,
            label: label,
            content: content,
            contentType: contentType,
            subjectDisplay: subjectDisplay,
            requireContent: false
          });
        };
      })(this);
      addAttachment(questionTitle, 'Question JSON-LD', jsonLdQuestion, 'application/ld+json');
      addAttachment(recommendationTitle, 'Recommendation JSON-LD', jsonLdRecommendation, 'application/ld+json');
      addAttachment(questionTitle, 'SoF Printout', sofHtml, 'text/html');
      addAttachment(recommendationTitle, 'Recommendation Printout', recommendationHtml, 'text/html');
      result = [
        {
          uuid: questionUuid,
          resource: {
            resourceType: 'EvidenceVariable',
            id: questionResourceId,
            meta: {
              profile: ['http://hl7.org/fhir/uv/ebm/StructureDefinition/exposure']
            },
            status: 'active',
            name: questionTitle,
            description: this._toSimpleString(questionTitle, 'Question'),
            text: this._toHtmlNarrative(sofHtml, "" + questionTitle + " SoF")
          }
        }
      ].concat(attachmentResources);
      recommendationPayload = recommendationJsonLd != null ? recommendationJsonLd : this._fallbackRecommendationJsonLd({
        id: questionId,
        title: recommendationTitle,
        text: recommendationHtml
      });
      this._prependRecommendationComposition({
        resources: result,
        recommendationId: (_ref6 = recommendationPayload != null ? recommendationPayload['@id'] : void 0) != null ? _ref6 : questionId,
        recommendationJsonLd: recommendationPayload,
        title: recommendationTitle,
        statementHtml: recommendationHtml,
        bundleMode: 'recommendation',
        placement: 'append',
        alwaysInclude: true
      });
      return result;
    },
    exportDocumentSections: function(_arg) {
      var mdaTopicId, projectId, _ref;
      _ref = _arg != null ? _arg : {}, projectId = _ref.projectId, mdaTopicId = _ref.mdaTopicId;
      if (projectId == null) {
        projectId = mediator.project.id;
      }
      return mediator.services.documentSectionsExportService["export"]({
        projectId: projectId,
        mdaTopicId: mdaTopicId
      }).then((function(_this) {
        return function(_arg1) {
          var chapters, guideline, sections;
          guideline = _arg1[0], chapters = _arg1[1], sections = _arg1[2];
          return _this._buildDocumentSectionsResources({
            guideline: guideline,
            chapters: chapters,
            sections: sections
          }).then(function(_arg2) {
            var attachmentRefsBySectionId, bookSectionTree, bundle, resources;
            resources = _arg2.resources, attachmentRefsBySectionId = _arg2.attachmentRefsBySectionId;
            bundle = _this._buildBundle('documentSections', resources, {
              guideline: guideline
            });
            bookSectionTree = _this._buildBookSectionTree({
              guideline: guideline,
              chapters: chapters,
              sections: sections,
              attachmentRefsBySectionId: attachmentRefsBySectionId
            });
            bundle.entry[0].resource.section = bookSectionTree;
            return bundle;
          });
        };
      })(this));
    },
    exportQuestion: function(_arg) {
      var jsonldService, questionData, questionModel, recommendationType;
      questionModel = (_arg != null ? _arg : {}).questionModel;
      if (!questionModel) {
        return W.reject(new Error('questionModelRequired'));
      }
      questionData = this._getQuestionData(questionModel);
      recommendationType = this._getRecommendationType();
      jsonldService = this._jsonldServiceForQuestion(questionModel);
      return W.all([jsonldService["export"](questionData, recommendationType), this._buildQuestionArtifacts(questionModel)]).then((function(_this) {
        return function(_arg1) {
          var artifacts, questionJsonLd, recommendationJsonLd, resources, _ref;
          (_ref = _arg1[0], questionJsonLd = _ref[0], recommendationJsonLd = _ref[1]), artifacts = _arg1[1];
          resources = _this._buildQuestionResources(questionJsonLd, recommendationJsonLd, artifacts);
          return _this._buildBundle('recommendation', resources);
        };
      })(this));
    }
  };
});
